import React from 'react'
import {
    BackButton,
    Bloc,
    BlocTextField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue22() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quelle est la situation professionnelle du second emprunteur?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton targetView={11} />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={60} time={2} />
            </div>
            <div className="Container">
                <Conditionnal linked_data_id="emprunteurs_cat_emploi_2" isEmpty>
                    <Bloc
                        key="key164"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value="PRIVE"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Salarié du privé"
                        text2="CDI cadre, CDI non cadre, CDI en période d’essai, CDD, Intérimaire, Intermittent du spectacle"
                    />
                    <Bloc
                        key="key165"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value="PUBLIC"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Salarié du public"
                        text2="Titulaire, Contractuel, Stagiaire"
                    />
                    <Bloc
                        key="key166"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value="NS"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Travailleur non salarié"
                        text2="Chef d’entreprise, Profession libérale, Artisan, Agriculteur, Travailleur indépendant Auto-entrepreneur, Commerçant"
                    />
                    <Bloc
                        key="key167"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value="AUTRE"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Autres"
                        text2="Congé parental, Retraité du secteur privé, Retraité du secteur public, En recherche d’emploi, Etudiant, Sans profession"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isEqualTo
                    targetDataValueCompare="PRIVE"
                >
                    <Bloc
                        key="key168"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Salarié du privé"
                    />
                    <Bloc
                        key="key169"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PRIVE_CDI_CADRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="CDI cadre"
                    />
                    <Bloc
                        key="key170"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PRIVE_CDI_NON_CADRE"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="CDI non cadre"
                    />
                    <Bloc
                        key="key171"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PRIVE_CDI_ESSAI"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="CDI en période d’essai"
                    />
                    <Bloc
                        key="key172"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PRIVE_CDD"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="CDD"
                    />
                    <Bloc
                        key="key173"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PRIVE_INTERIM"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Intérimaire"
                    />
                    <Bloc
                        key="key174"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PRIVE_INTERMITTENT"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Intermittent du spectacle"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isEqualTo
                    targetDataValueCompare="PUBLIC"
                >
                    <Bloc
                        key="key175"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Salarié du public"
                    />
                    <Bloc
                        key="key176"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PUBLIC_TITULAIRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Titulaire"
                    />
                    <Bloc
                        key="key177"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PUBLIC_CONTRACTUEL"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Contractuel"
                    />
                    <Bloc
                        key="key178"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="PUBLIC_STAGIAIRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Stagiaire"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isEqualTo
                    targetDataValueCompare="NS"
                >
                    <Bloc
                        key="key179"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Travailleur non salarié"
                    />
                    <Bloc
                        key="key180"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="NS_CHEF_ENTREPRISE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Chef d’entreprise"
                    />
                    <Bloc
                        key="key181"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="NS_PRO_LIBERALE"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Profession libérale"
                    />
                    <Bloc
                        key="key182"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="NS_ARTISAN"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Artisan"
                    />
                    <Bloc
                        key="key183"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="NS_AGRI"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Agriculteur"
                    />
                    <Bloc
                        key="key184"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="NS_INDEPENDANT"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Travailleur indépendant / Auto-entrepreneur"
                    />
                    <Bloc
                        key="key185"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="NS_COMMERCANT"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Commerçant"
                    />

                    <Conditionnal
                        linked_data_id="emprunteurs_type_emploi_2"
                        isNotEmpty
                    >
                        <Title maintitle="Combien de bilans avez-vous?" />
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_2"
                            isEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <Bloc
                                key="key76"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_2"
                                linked_data_value="SUFFISANT"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Plus de 2 bilans"
                            />
                            <Bloc
                                key="key77"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_2"
                                linked_data_value="INSUFFISANT"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Moins de 2 bilans"
                            />
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_2"
                            isNotEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <Bloc
                                key="key76"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_2"
                                linked_data_value="SUFFISANT"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Plus de 3 bilans"
                            />
                            <Bloc
                                key="key77"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_2"
                                linked_data_value="INSUFFISANT"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Moins de 3 bilans"
                            />
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isEqualTo
                    targetDataValueCompare="AUTRE"
                >
                    <Bloc
                        key="key186"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_2"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Autres"
                    />
                    <Bloc
                        key="key187"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="AUTRE_CP"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Congé parental"
                    />
                    <Bloc
                        key="key188"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="AUTRE_RET_PRIVE"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Retraité du secteur privé"
                    />
                    <Bloc
                        key="key189"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="AUTRE_RET_PUBLIC"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Retraité du secteur public"
                    />
                    <Bloc
                        key="key190"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="AUTRE_RECH_EMPLOI"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="En recherche d’emploi"
                    />
                    <Bloc
                        key="key191"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="AUTRE_ETUDIANT"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Etudiant"
                    />
                    <Bloc
                        key="key192"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_2"
                        linked_data_value="AUTRE_SANS_PROFESSION"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Sans profession"
                    />
                </Conditionnal>
            </div>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_2"
                isEqualTo
                targetDataValueCompare="PRIVE_CDD"
            >
                <div className="Container">
                    <Title
                        maintitle="Le second emprunteur a un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key194"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key195"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_2"
                isEqualTo
                targetDataValueCompare="PRIVE_INTERIM"
            >
                <div className="Container">
                    <Title
                        maintitle="Le second emprunteur a un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key197"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key198"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_2"
                isEqualTo
                targetDataValueCompare="PRIVE_INTERMITTENT"
            >
                <div className="Container">
                    <Title
                        maintitle="Le second emprunteur a un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key200"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key201"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_2"
                isEqualTo
                targetDataValueCompare="NS_INDEPENDANT"
            >
                <div className="Container">
                    <Title
                        maintitle="Le second emprunteur a un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key203"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key204"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_2"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <div className="Container">
                <Title maintitle="Quel âge a le second emprunteur ?" />
                <BlocTextField
                    nbcolumn={1}
                    linked_data_id="emprunteurs_date_naissance_2"
                    label="Date de naissance"
                    placeholder="Ex : jour/mois/année : 30/05/1991"
                    checkedByRegex={
                        /^(((0[1-9]|[12][0-9]|30)[/]{1}(0[13-9]|1[012])|31[/]{1}(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[/]{1}02)[/]{1}[0-9]{4}|29[/]{1}02[/]{1}([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/
                    }
                    messageErreur={'Vous devez avoir entre 18 et 80 ans'}
                    verificationAge18a80Ans
                    autoCompletionDate
                />
            </div>

            <Conditionnal linked_data_id="emprunteurs_type_emploi_2" isNotEmpty>
                <Conditionnal
                    linked_data_id="emprunteurs_date_naissance_2_validated"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <Conditionnal
                        linked_data_id="emprunteurs_cat_emploi_2"
                        isEqualTo
                        targetDataValueCompare="NS"
                    >
                        <Conditionnal
                            linked_data_id="emprunteurs_emploi_bilan_2"
                            isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={23} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="emprunteurs_cat_emploi_2"
                        isNotEqualTo
                        targetDataValueCompare="NS"
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={23} />{' '}
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
